<template>
  <div class="form-sospensioni">
    <!-- Riga 1: POD e Codice Pratica -->
    <div class="p-field">
      <label for="cod_pod">POD (COD_POD) *</label>
      <InputText id="cod_pod" v-model="formData.cod_pod" placeholder="IT001E81399750" class="w-full"
        :class="{ 'p-invalid': hasError('cod_pod') }" />
    </div>

    <div class="p-field">
      <label for="cp_utente">Codice Pratica (CP_UTENTE)</label>
      <InputText id="cp_utente" v-model="formData.cp_utente" placeholder="Lascia vuoto per generazione automatica" class="w-full"
        :class="{ 'p-invalid': hasError('cp_utente') }" />
      <small class="text-muted">Se non compilato, verrà generato automaticamente</small>
    </div>

    <!-- Riga 2: P.IVA Utente e Gestore -->
    <div class="p-field">
      <label for="piva_utente">P.IVA Utente (PIVA_UTENTE) *</label>
      <InputText id="piva_utente" v-model="formData.piva_utente" placeholder="08150620725 (default consigliato)" class="w-full"
        maxlength="11" />
      <small class="text-muted">Default: 08150620725</small>
    </div>

    <div class="p-field">
      <label for="piva_gestore">P.IVA Gestore (PIVA_GESTORE) *</label>
      <InputText id="piva_gestore" v-model="formData.piva_gestore" placeholder="05877611003 (default consigliato)" class="w-full"
        maxlength="11" />
      <small class="text-muted">Default: 05877611003</small>
    </div>

    <!-- Riga 3: Codice Prestazione e Controparte Dispacciamento -->
    <div class="p-field">
      <label for="cod_prestazione">Codice Prestazione (COD_PRESTAZIONE) *</label>
      <Dropdown id="cod_prestazione" v-model="formData.cod_prestazione" :options="codiciPrestazione" optionLabel="label"
        optionValue="value" placeholder="Seleziona prestazione" class="w-full" />
    </div>

    <div class="p-field">
      <label for="cod_contr_disp">Codice Controparte Dispacciamento (COD_CONTR_DISP) *</label>
      <InputText id="cod_contr_disp" v-model="formData.cod_contr_disp" placeholder="Es: DP2468" class="w-full"
        :class="{ 'p-invalid': hasError('cod_contr_disp') }" />
    </div>

    <!-- Riga 4: Importo Morosità e CF -->
    <div class="p-field">
      <label for="importo_morosita">Importo Morosità (IMPORTO_MOROSITA) *</label>
      <InputNumber id="importo_morosita" v-model="formData.importo_morosita" mode="currency" currency="EUR"
        locale="it-IT" placeholder="0.00 (default)" class="w-full" :minFractionDigits="2" :maxFractionDigits="2" />
      <small class="text-muted">Default: 0.00</small>
    </div>

    <div class="p-field">
      <label for="cf">Codice Fiscale (CF) **</label>
      <InputText id="cf" v-model="formData.cf" placeholder="RSSMRA80A41H501Y" class="w-full" maxlength="16"
        style="text-transform: uppercase" />
      <small class="text-muted">** Obbligatorio se P.IVA Cliente non è presente</small>
    </div>

    <!-- Riga 5: P.IVA Cliente e CF Straniero -->
    <div class="p-field">
      <label for="piva">P.IVA Cliente (PIVA) **</label>
      <InputText id="piva" v-model="formData.piva" placeholder="12345678901" class="w-full" maxlength="11" />
      <small class="text-muted">** Obbligatorio se CF non è presente</small>
    </div>

    <div class="p-field">
      <label for="cf_straniero">CF Straniero (CF_STRANIERO)</label>
      <InputText id="cf_straniero" v-model="formData.cf_straniero" placeholder="CF straniero (opzionale)"
        class="w-full" />
      <small class="text-muted">Opzionale - per cittadini non italiani</small>
    </div>

    <!-- Riga 6: Telefono e Email (opzionali) -->
    <div class="p-field">
      <label for="telefono">Telefono (TELEFONO)</label>
      <InputText id="telefono" v-model="formData.telefono" placeholder="+39 123 4567890" class="w-full" />
    </div>

    <div class="p-field">
      <label for="email">Email (EMAIL)</label>
      <InputText id="email" v-model="formData.email" type="email" placeholder="cliente@example.com" class="w-full" />
    </div>
  </div>
</template>

<script>
import { reactive, watch } from 'vue';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Dropdown from 'primevue/dropdown';

export default {
  name: 'SospensioniForm',
  components: {
    InputText,
    InputNumber,
    Dropdown
  },
  props: {
    modelValue: {
      type: Object,
      default: () => ({})
    },
    errorFields: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const formData = reactive({
      cod_servizio: 'SM1',
      cod_flusso: '0050',
      piva_utente: '08150620725',
      piva_gestore: '05877611003',
      cp_utente: '',
      cod_pod: '',
      cod_prestazione: '',
      cod_contr_disp: '',
      importo_morosita: 0.00,
      cf: '',
      piva: '',
      cf_straniero: '',
      telefono: '',
      email: ''
    });

    const codiciPrestazione = [
      { label: 'M01 - Sospensione per morosità', value: 'M01' },
      { label: 'M02 - Sospensione ai sensi del 5.2 del TIMOE', value: 'M02' }
    ];

    watch(formData, (newValue) => {
      emit('update:modelValue', { ...newValue });
    }, { deep: true });

    watch(() => props.modelValue, (newValue) => {
      if (newValue) {
        const sanitizedValue = { ...newValue };
        if (sanitizedValue.importo_morosita && typeof sanitizedValue.importo_morosita === 'string') {
          sanitizedValue.importo_morosita = parseFloat(sanitizedValue.importo_morosita);
        }
        Object.assign(formData, sanitizedValue);
      }
    }, { immediate: true, deep: true });

    const hasError = (fieldName) => {
      return props.errorFields.includes(fieldName);
    };

    return {
      formData,
      codiciPrestazione,
      hasError
    };
  }
};
</script>

<style scoped>
.form-sospensioni {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;
}

.p-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.p-field label {
  font-weight: 600;
  color: #495057;
  font-size: 0.9rem;
}

.p-field small.text-muted {
  color: #6c757d;
  font-size: 0.8rem;
  margin-top: -0.25rem;
}

/* Note field occupa tutta la larghezza */
.full-width {
  grid-column: 1 / -1;
}

/* Input uppercase per CF */
:deep(#cf) {
  text-transform: uppercase;
}

/* Campo in errore - bordo rosso */
:deep(.p-invalid) {
  border-color: #f44336 !important;
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.25) !important;
}

:deep(.p-invalid:focus) {
  border-color: #f44336 !important;
  box-shadow: 0 0 0 0.2rem rgba(244, 67, 54, 0.35) !important;
}

@media (max-width: 768px) {
  .form-sospensioni {
    grid-template-columns: 1fr;
  }
}
</style>
